import { render, staticRenderFns } from "./ImportEmailSettings.vue?vue&type=template&id=e04f631c"
import script from "./ImportEmailSettings.vue?vue&type=script&lang=js"
export * from "./ImportEmailSettings.vue?vue&type=script&lang=js"
import style0 from "./ImportEmailSettings.vue?vue&type=style&index=0&id=e04f631c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports